module.exports = __webpack_public_path__ + "img/image_4.06ea0492.jpg";